export default [
    {
        title: 'CsSolicitudPreferencia',
        load: () => import('@/modules/CustomerService/SolicitudCita/components/SolicitudPreferencia.vue')
    },
    {
        title: 'CsTipoPqrs',
        load: () => import('@/modules/CustomerService/Pqrs/components/TipoPqrs.vue')
    }
];
